<template>
    <div class="mt-3 mb-3 ">
    <h5>Bank Transfer to our DBS account</h5>
    <div class="d-flex  flex-wrap flex-md-nowrap templete-reference">
      <div class="mr-3 first-area">
        <div>
          Healthserve Ltd<br/>
          Account No: 0339018872 <br/>
          Bank: 7171 <br/>
          Branch: 033
        </div>
      </div>
      <div class="second-area">
            <div class="bg-hs-pastel-crimson p-3">
              <h5 style="margin-bottom: 3px; font-weight: bold; font-size: 16px; line-height: 24px;">Your reference number </h5>
              <code>{{checkout.Reference}}</code>
            </div>
      </div>
    </div>
    </div>

</template>

<script>
export default {
    name:"bank",
    props:{
        checkout: Object
    }
}
</script>

<style>

</style>